import { callPostExternalApi } from '@ctn/axios-util';

import { type IMaestro } from '@/interfaces/model/maestros.interface';
import { processError } from '@/utils/axiosErrors';
import axiosInstance from '@/utils/axiosInterceptor';

const getBackendUrl = () => ({
	GET_DOCUMENTO: '/documentos/contenido',
});

export type SolicitudesDocumentoPayload = {
	idDocumento: number;
	idSolicitud: number;
	tipoSector: IMaestro;
	nifEmisor: string;
};

const getSolicitudDocumento = async (data: SolicitudesDocumentoPayload) =>
	callPostExternalApi<string>({ axiosInstance, data, withCredentials: true, url: getBackendUrl().GET_DOCUMENTO, processError });

export { getSolicitudDocumento };
